import { Button } from '@commenda/kakashi';
import Modal from '../modal';

interface ConfirmDeleteModalProp {
  isDeleteModalShowed: boolean;
  toggleDeleteModal: () => void;
  headerText?: string;
  modalMessage: string;
  onDelete?: () => void;
  _css?: string;
}

const ConfirmDeleteModal = ({
  isDeleteModalShowed,
  toggleDeleteModal,
  headerText,
  modalMessage,
  onDelete,
  _css,
}: ConfirmDeleteModalProp) => {
  return (
    <Modal
      headerText={headerText}
      isShown={isDeleteModalShowed}
      hide={toggleDeleteModal}
      additionalClassName={_css}
    >
      <div className="mt-2">
        <p className="text-sm text-gray-500">{modalMessage}</p>
      </div>
      <div className="pt-[5%] sm:mt-4 flex justify-center gap-2">
        <Button variant="destructive-primary" size="sm" onClick={onDelete}>
          Delete
        </Button>
        <Button variant="secondary" size="sm" onClick={toggleDeleteModal}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
